import styled from 'styled-components';
import { buttonResetStyleIncludingFocus } from '../../../commonStyles/buttonReset';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import Icon from '../../Icon';

export const NavDropdown = styled.div`
  position: absolute;
  background-color: ${colors.neutral08};
  width: 100%;
`;

export const InPageNavContainer = styled.div`
  padding-top: ${spacing(2)};
  padding-bottom: ${spacing(2)};
  background-color: ${colors.neutral08};

  position: sticky;
  top: 0;
  z-index: 1;

  ${mediaQuery.tabletLandscape`
    display: none;
  `}
`;

export const NavButton = styled.button`
  ${buttonResetStyleIncludingFocus};

  width: 100%;
  padding-left: ${spacing(3)};
  display: flex;
  justify-content: space-between;
  text-align: left;
  text-decoration: none;
  border-left: solid 2px ${colors.neutral05};
`;

export const NavHeading = styled.h2`
  ${fonts.headingXSmall}
  margin: ${spacing(1)} 0;
`;

export const StyledIcon = styled(Icon)`
  margin: auto 0 auto ${spacing(2)};
`;
